import React from "react";

function StepPage() {
    return (
        <section className="steps-section">
            <div className="steps-container">
                <div className="step-card">
                    <div className="step-number">1</div>
                    <div className="step-icon">
                        <img src={require("./img/upload.png")} alt="Upload" />
                    </div>
                    <div className="step-content">
                        <h3 className="step-title">Upload</h3>
                        <p className="step-description">
                            Upload your raw dataset<br/>
                            photos, videos, or audio to the cloud
                        </p>
                        <p className="step-highlight">
                            Efficiently data transfer,<br/>
                            get precise labeling,<br/>
                            and swift insights.
                        </p>
                    </div>
                </div>
                
                <div className="step-card">
                    <div className="step-number">2</div>
                    <div className="step-icon">
                        <img src={require("./img/train.png")} alt="Train" />
                    </div>
                    <div className="step-content">
                        <h3 className="step-title">Train</h3>
                        <p className="step-description">
                            We will manually label the raw dataset<br/>
                            based on your specifications and conduct AI model training
                        </p>
                        <p className="step-highlight">
                            Save time for your workflow
                        </p>
                    </div>
                </div>
                
                <div className="step-card">
                    <div className="step-number">3</div>
                    <div className="step-icon">
                        <img src={require("./img/analysis.png")} alt="Analysis" />
                    </div>
                    <div className="step-content">
                        <h3 className="step-title">Analysis</h3>
                        <p className="step-description">
                            The data results will be presented according to your individual preferences, using formats<br/>
                            like Excel, charts, or any other method of your choice.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default StepPage
